import React from "react";
import Popup from "./Popup";

const CareerPopup = ({ name, title, text }) => (
  <Popup name={name} className="popup-job-story">
    <div className="popup-job-story__content">
      <div className="popup-job-story__name">{title}</div>
    </div>
    <div className="popup-job-story__content">
      <div className="popup-job-story__text" dangerouslySetInnerHTML={{__html: text}} />
    </div>
  </Popup>
);

export default CareerPopup;
